import { FooterContainer, FooterLinks } from './styles';
import { INE_URL } from 'constants/settings';
import { showHubSpotCookieBanner } from 'utils/hubspot';

const Footer = (): JSX.Element => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterLinks>
        <span>© {currentYear} INE</span>
        <a
          href={`${INE_URL}/terms-of-service`}
          title={'Terms of services'}
          target="_blank"
          rel="noreferrer noopener"
        >
          Terms of services
        </a>
        <a
          href={'https://checkout.shopify.com/17217507/policies/16723845.html'}
          title={'Privacy policy'}
          target="_blank"
          rel="noreferrer noopener"
        >
          Privacy policy
        </a>
        <button
          id="hs_show_banner_button"
          type="button"
          title={'Cookie settings'}
          onClick={showHubSpotCookieBanner}
        >
          Cookie settings
        </button>
        <a
          href={'https://discord.gg/8zwaY7VUdU'}
          title={'INE Community'}
          target="_blank"
          rel="noreferrer noopener"
        >
          INE Community
        </a>
        <a href={`${INE_URL}/faqs`} title={'Help Center'} target="_blank" rel="noreferrer noopener">
          Help Center
        </a>
      </FooterLinks>
    </FooterContainer>
  );
};

export default Footer;
